export default {
  page_title: ['Action Library', 'Action Library'],
  create_button: ['Create New Action Template', 'Create New Action Template'],
  create_subtitle: [
    'Here you can create a new action template. Define its properties and create a checklist of steps to follow.',
    'Here you can create a new action template. Define its properties and create a checklist of steps to follow.',
  ],
  edit_subtitle: [
    'Here you can edit the action template. Update its properties and modify the checklist of steps.',
    'Here you can edit the action template. Update its properties and modify the checklist of steps.',
  ],
  empty_state: {
    title: ['No matching templates found', 'No matching templates found'],
    description: ['Try adjusting your filters or search criteria', 'Try adjusting your filters or search criteria'],
    reset_filters: ['Reset Filters', 'Reset Filters'],
  },
  error_state: {
    title: ['Something went wrong', 'Something went wrong'],
    description: ['Failed to load action templates. Please try again.', 'Failed to load action templates. Please try again.'],
    retry: ['Retry', 'Retry'],
    unauthorized: {
      title: ['Unauthorized Access', 'Unauthorized Access'],
      description: ['You do not have permission to access this resource.', 'You do not have permission to access this resource.'],
      back_to_start: ['Back to Start', 'Back to Start'],
    },
    timeout: {
      title: ['Request Timeout', 'Request Timeout'],
      description: [
        'The request took too long to complete. Please check your connection and try again.',
        'The request took too long to complete. Please check your connection and try again.',
      ],
      retry: ['Retry', 'Retry'],
    },
  },
  table: {
    name: ['Name', 'Name'],
    purpose: ['Purpose', 'Purpose'],
    area: ['Area', 'Area'],
    subarea: ['Subarea', 'Subarea'],
    status: ['Status', 'Status'],
    criticality: ['Criticality', 'Criticality'],
    creator: ['Creator', 'Creator'],
    actions: ['Actions', 'Actions'],
    show_more: ['Show More', 'Show More'],
  },
  detail: {
    page_title: ['Action Template Details', 'Action Template Details'],
    title: ['Action Template Details', 'Action Template Details'],
    description: ['Description', 'Description'],
    tags: ['Tags', 'Tags'],
    steps: ['Steps', 'Steps'],
    created_at: ['Created At', 'Created At'],
    updated_at: ['Updated At', 'Updated At'],
    created_by: ['Created By', 'Created By'],
    validity_period: ['Validity Period', 'Validity Period'],
    owner_organization: ['Owner Organization', 'Owner Organization'],
    asset_types: ['Asset Types', 'Asset Types'],
    reference: ['Reference', 'Reference'],
    reported_to: ['Reported To', 'Reported To'],
  },
  actions: {
    activate: ['Activate', 'Activate'],
    deactivate: ['Deactivate', 'Deactivate'],
    copy: ['Copy', 'Copy'],
    print: ['Print', 'Print'],
    delete: ['Delete', 'Delete'],
    edit: ['Edit', 'Edit'],
  },
  status: {
    active: ['Active', 'Active'],
    inactive: ['Inactive', 'Inactive'],
    draft: ['Draft', 'Draft'],
  },
  criticality: {
    LOW: ['Low', 'Low'],
    MEDIUM: ['Medium', 'Medium'],
    HIGH: ['High', 'High'],
  },
  creator: {
    PocketSafe: ['PocketSafe', 'PocketSafe'],
    Organization: ['Organization', 'Organization'],
  },
  delete_confirmation: {
    title: ['Delete Action Template', 'Delete Action Template'],
    body: [
      'Are you sure you want to delete this action template? This action cannot be undone.',
      'Are you sure you want to delete this action template? This action cannot be undone.',
    ],
    confirm: ['Delete', 'Delete'],
    cancel: ['Cancel', 'Cancel'],
  },
  success: {
    created: ['Action template created successfully', 'Action template created successfully'],
    updated: ['Action template updated successfully', 'Action template updated successfully'],
    deleted: ['Action template deleted successfully', 'Action template deleted successfully'],
    activated: ['Action template activated successfully', 'Action template activated successfully'],
    deactivated: ['Action template deactivated successfully', 'Action template deactivated successfully'],
    copied: ['Action template copied successfully', 'Action template copied successfully'],
  },
  filters: {
    purpose: ['Purpose', 'Purpose'],
    area: ['Area', 'Area'],
    subarea: ['Subarea', 'Subarea'],
    status: ['Status', 'Status'],
    criticality: ['Criticality', 'Criticality'],
    creator: ['Creator', 'Creator'],
  },
};
